import React from 'react'
import './style.css'

class PersonItem extends React.Component {
  render() {
    const { displayTags, displayTitle, thumbnailImage, thumbnail, item: { tags }} = this.props
    return <a href={this.props.item.permalink} className="tray-person-item">
        <div className="image-container">
          <div className="image" style={{ backgroundImage: `url(${thumbnailImage ? thumbnailImage : thumbnail})` }}>
          {
          	displayTags && (
				<div className="details inline">
				{
					tags.map(tag => (
							<span className="title" key={tag.id}>
								{tag.title}
							</span>
					))
				}
				</div>
          	)
          }
          </div>
        </div>
		{
			displayTitle && (
			<div className="details bottom">
				<p className="title">
					{this.props.item.firstName} {this.props.item.lastName}
				</p>
			</div>          		
			)
		}
      </a>;
  }

}

export default PersonItem;